module.exports = __webpack_public_path__ + "static/media/no_plane.7c353191.png";